export class Search {
    constructor(selector) {
        this.input = $(selector);

        $(document).on('focus', selector, () => {
            this.showSearch();
        });

        $(document).on('focusout', selector, (event) => {
            let toElem = event.relatedTarget;
            if (!toElem || (toElem && toElem.type !== 'submit')) {
                this.hideSearch();
            }
        });

        $(document).on('keyup', (e) => {
            if (e.keyCode === 27) {
                this.hideSearch();
            }
        });
    }

    showSearch() {
        $(this.input).closest('.js-header-search').addClass('active');
    }

    hideSearch() {
        $(this.input).closest('.js-header-search').removeClass('active');
    }
}
